import { UAE_REDIRECT_ROUTE, isUaeBlockedRoute } from '~/utils/uae-gate-client/uaeGate';

// UAE agents never see pricing / billing pages (ID-106): send them to the dashboard setup guide.
export default defineNuxtRouteMiddleware((to) => {
  // The UAE flag lives in the client-persisted session; the first SSR page is covered by the client plugin.
  if (import.meta.server || !isUaeBlockedRoute(to.path)) return;
  const { isUae, isUaeTeamOwner } = useUaeGate();
  // ID-241: a UAE Team owner keeps their team page.
  if (!isUaeBlockedRoute(to.path, { teamOwner: isUaeTeamOwner.value })) return;
  if (isUae.value) return navigateTo(UAE_REDIRECT_ROUTE, { replace: true });
});
